<template>
	<div
		class="field-item field-item--grow"
		:class="isInlineFieldItemClassname"
	>
		<label
			v-if="label"
			class="field-label"
			:class="isInlineLabelClassname"
		>{{ label }}</label>
		<div class="button-wrapper">
			<i
				:class="isFieldAvailableClassname"
				class="fas fa-photo-video mr--15"
			></i>
			<div
				@click="assetsOpen"
				class="button--media"
				aria-label="field-media-open"
				:class="[isFieldAvailableClassname, notAvailableFieldTooltip]"
			>
				<i
					v-if="image"
					@click.stop="mediaRemove"
					aria-label="field-media-remove"
					class="fas fa-times media-close"
				></i>
				<i class="fas fa-plus"></i>
				<img aria-label="field-image" v-if="image" :src="mediaComputed" alt="">
				<span v-if="showUrl">or</span>
				<div v-if="!isFieldAvailable" class="tooltip__item bottom">{{ t('tooltip.noAccess') }}</div>
			</div>
			<div v-if="showUrl" class="field">
				<input v-model="mediaURL" type="text" :placeholder="t('field.appearance.mediaUrl')">
			</div>
		</div>
	</div>
</template>
<script>
import {computed} from 'vue';
import {useStore} from 'vuex';
import useI18nGlobal from '@/utils/i18n';
const {i18n} = useI18nGlobal();
const { t } = i18n.global;
export default {
	emits: {
		"update:imageURL": () => true,
		"update:image": () => true,
		"image-updated": () => true,
		"image-url-updated": () => true,
		"popup-open": () => true,
	},
	props: {
		label: {
			type: String,
			default: t('field.appearance.media')
		},
		labelInline: {
			type: Boolean,
			default: false
		},
		showUrl:{
			type: Boolean,
			default: true,
		},
		image: {
			type: String,
		},
		imageURL: {
			type: String
		}
	},
	setup(props, {emit}) {
		const store = useStore();
		const baseURL = import.meta.env.VITE_ROOT_HOST;
		
		const mediaComputed = computed(() => props.image.includes(baseURL) ? props.image : `${baseURL}${props.image}`);
		const mediaURL = computed({
			get: () => props.imageURL,
			set: async value => {
				let error = false;
				value === '' ? value = null : checkIfImageExists(value, exist => {exist ? console.log('image exist') : console.log('image not exist')});
				if(value?.trim() === '') value = null;
				emit("update:imageURL", value);
				emit("image-url-updated", value);
				emit("update:image", null);
				emit("image-updated", null);
			}
		});
		
		// CHECK IF IMAGE EXISTS
		function checkIfImageExists(url, callback) {
			const img = new Image();
			img.src = url;
			
			if (img.complete) {
				callback(true);
			} else {
				img.onload = () => {
					callback(true);
				};
				img.onerror = () => {
					callback(false);
				};
			}
		}
		
		async function checkImageExist(imageUrl){
			try{
				const response = await fetch(imageUrl, {method: 'HEAD', mode: 'no-cors', cache: 'no-cache'})
				console.log(response);
				return Promise.resolve(false);
			} catch(err){
				console.log(err);
				return Promise.reject(true);
			}
		}
		
		// CLIENT RESTRICTIONS
		const clientRestrictions = computed(() => store.getters["clients/getRestrictions"]);
		const hasAssetManagement = computed(() => clientRestrictions.value.hasAssetManagement.value);
		const hasMediaTemplates = computed(() => clientRestrictions.value.hasMediaTemplates.value);
		const isFieldAvailable = computed(()=> hasAssetManagement.value || hasMediaTemplates.value);
		const isFieldAvailableClassname = computed(() => isFieldAvailable.value ? "" : "disabled");
		const notAvailableFieldTooltip = computed(() => !isFieldAvailable.value ? "tooltip tooltip--centered dark" : "");
		
		const isInlineLabelClassname = computed(() => props.labelInline ? '' : 'mb--15');
		const isInlineFieldItemClassname = computed(() => props.labelInline ? '' : 'field-item--column');
		
		function   mediaRemove(){
			emit("update:image", null);
		}
		
		function assetsOpen(){
			if(!isFieldAvailable.value) return;
			emit('popup-open');
		}
		
		return {
			t,
			isFieldAvailable,
			isFieldAvailableClassname,
			notAvailableFieldTooltip,
			mediaComputed,
			mediaURL,
			isInlineLabelClassname,
			isInlineFieldItemClassname,
			mediaRemove,
			assetsOpen
		}
	}
}
</script>

<style lang="scss"></style>
